/* Mayfer motion engine — scroll reveal, header behavior, motif parallax.
   Tasteful, accessible, no dependencies. Deferred. */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function initReveal() {
    var nodes = document.querySelectorAll('[data-mf-reveal]');
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          obs.unobserve(e.target); // reveal once, never re-animate
        }
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  // --- Header + parallax share one rAF-throttled scroll loop ---------------
  function initScroll() {
    var header = document.querySelector('[data-mf-header]');
    var spacer = document.querySelector('[data-mf-header-spacer]');
    var lastY = window.scrollY;
    var ticking = false;

    // The header is position:fixed, so a spacer reserves its full (top) height
    // and content never slides under it. Measure only at the top, where the
    // header is in its full (uncollapsed, large-logo) state.
    function sizeSpacer() {
      if (header && spacer && !docEl.classList.contains('mf-scrolled')) {
        spacer.style.height = header.offsetHeight + 'px';
      }
    }
    sizeSpacer();
    window.addEventListener('resize', sizeSpacer, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sizeSpacer);
    }

    // Collect decorative motifs once (speed + rotation baked into transform).
    var motifs = [];
    var nodes = document.querySelectorAll('.brand-motif');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var sp = parseFloat(el.getAttribute('data-mf-parallax'));
      motifs.push({
        el: el,
        speed: isNaN(sp) ? 0.16 : sp,
        rot: parseFloat(el.getAttribute('data-mf-rot')) || 0
      });
    }
    var doParallax = !reduce && motifs.length > 0;

    function parallax() {
      var vh = window.innerHeight;
      var mid = vh / 2;
      for (var i = 0; i < motifs.length; i++) {
        var m = motifs[i];
        var r = m.el.getBoundingClientRect();
        if (r.bottom < -300 || r.top > vh + 300) continue; // off-screen → skip
        var center = r.top + r.height / 2;
        var off = (mid - center) * m.speed;
        if (off > 240) off = 240; else if (off < -240) off = -240;
        m.el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) rotate(' + m.rot + 'deg)';
      }
    }

    function update() {
      var y = window.scrollY;
      docEl.classList.toggle('mf-scrolled', y > 8);
      if (header) {
        if (y <= 8) {
          header.classList.remove('is-hidden'); // always visible at the top
        } else if (y > 240 && y > lastY + 4) {
          header.classList.add('is-hidden'); // scrolling down → hide
        } else if (y < lastY - 4) {
          header.classList.remove('is-hidden'); // scrolling up → show
        }
      }
      if (doParallax) parallax();
      lastY = y;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function start() {
    initScroll();

    // Reveal waits until webfonts are ready so text never flashes from the
    // fallback to the brand font. Hard 1200ms cap so a slow font never blocks.
    if (document.fonts && document.fonts.ready) {
      var cap = new Promise(function (resolve) { setTimeout(resolve, 1200); });
      Promise.race([document.fonts.ready, cap]).then(initReveal, initReveal);
    } else {
      initReveal();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
